import React from "react";
import { Editor } from "react-draft-wysiwyg";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { convertToRaw, ContentState } from "draft-js";
const CkEditorFull = (props) => {
  const { form, field } = props;
  const [editorStateR, setEditorStateR] = React.useState(null);
  return (
    <div className="col-span-2 border p-2 min-h-60">
      <label className="leading-2 text-white mb-3">{props.label}</label>
      <Editor
        wrapperClassName="rdw-c-wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        editorState={editorStateR}
        onEditorStateChange={(editorState) => {
          setEditorStateR(editorState);
          form.setFieldValue(
            field.name,
            draftToHtml(
              convertToRaw(editorState.getCurrentContent()),
              {},
              false,
              ({ type, data }) => {
                //entity.data.alignment is for float using the LCR options on the image 'none' means the user clicked center
                if (type === "IMAGE") {
                  const alignment = data.alignment || "none";
                  const textAlign = alignment === "none" ? "center" : alignment;

                  return `
                          <p style="text-align:${textAlign};">
                              <img src="${data.src}" alt="${data.alt}" style="height: ${data.height};width: ${data.width}"/>
                          </p>
                      `;
                }
              }
            )
          );
        }}
      />
      <style jsx global>{`
        .rdw-c-wrapper-class,
        .editor-class,
        .toolbar-class {
          background: #232a3b !important;
          color: white;
        }
        .rdw-option-wrapper {
          background: #313a55 !important;
        }
        .ck .ck-button__label {
          color: white !important;
        }

        .rdw-dropdown-wrapper {
          background: none !important;
        }

        .rdw-fontfamily-optionwrapper,
        .rdw-dropdown-optionwrapper {
          background: gray !important;
        }
        .rdw-dropdownoption-default:hover {
          color: black !important;
        }
        .rdw-dropdownoption-active {
          color: black !important;
        }

        .rdw-editor-main {
          padding: 10px;
        }
      `}</style>
    </div>
    
  );
};

export default CkEditorFull;
